export default {
  'Choose File': 'Escolher arquivo',
  'Please paste a URL': 'Por favor, cole um URL',
  'Loading': 'Carregando',
  'Analyzing': 'Analisando',
  'Try a sample': 'Experimente uma amostra',
  'Sorry, error occurs when analyzing the URL.': 'Desculpe, ocorreu um erro ao analisar o URL.',
}